var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/es-abstract/helpers/isFinite.js
// module id = 635
// module chunks = 168707334958949